<template>
    <van-popup v-if="relateFormPopupShow " :value="relateFormPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="relate_form_wrap" ref="recordDialog" >
            <div class="relate_form_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>

            <div class="relate_form_bottom">
                <van-form colon ref="formData" scroll-to-error label-width="100px">
                    <ul v-if="relateType == 'relate_business'">
                        <li>
                            <van-field :rules="formRules.relate" @click="selectBusinessPopupShow = true" input-align="right"  label="选择关联商机" :value="formData.relate.map(map => map.project_name).join(',')"  placeholder="请选择" required is-link ></van-field>
                        </li>
                        <van-checkbox-group v-model="formData.sync">
                            <van-cell-group>
                                <van-cell   clickable  title="同步关联订单"  @click="toggle('orderRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="order" ref="orderRef" />
                                    </template>
                                </van-cell>
                                <van-cell   clickable  title="同步关联工单"  @click="toggle('workOrderRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="workorder" ref="workOrderRef" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                    </ul>
                    <ul v-if="relateType == 'relate_order'">
                        <li>
                            <van-field :rules="formRules.relate" @click="selectOrderPopupShow = true" input-align="right"  label="选择关联订单" :value="formData.relate.map(map => map.order_num).join(',')"  placeholder="请选择" required is-link ></van-field>
                        </li>
                        <van-checkbox-group v-model="formData.sync">
                            <van-cell-group>
                                <van-cell   clickable  title="同步关联商机"  @click="toggle('projectRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="project" ref="projectRef" />
                                    </template>
                                </van-cell>
                                <van-cell   clickable  title="同步关联工单"  @click="toggle('workOrderRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="workorder" ref="workOrderRef" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                    </ul>
                    <ul v-if="relateType == 'relate_work_order'">
                        <li>
                            <van-field :rules="formRules.relate" @click="selectWorkOrderPopupShow = true" input-align="right"  label="选择关联工单" :value="formData.relate.map(map => map.workorder_num).join(',')"  placeholder="请选择" required is-link ></van-field>
                        </li>
                        <van-checkbox-group v-model="formData.sync">
                            <van-cell-group>
                                <van-cell   clickable  title="同步关联商机"  @click="toggle('projectRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="project" ref="projectRef" />
                                    </template>
                                </van-cell>
                                <van-cell   clickable  title="同步关联订单"  @click="toggle('orderRef')" >
                                    <template #right-icon>
                                        <van-checkbox name="order" ref="orderRef" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                    </ul>
                </van-form>
            </div>

            <div class="relate_form_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
            </div>


        </div>
        <SelectOrder v-if="selectOrderPopupShow" :selectOrderPopupShow.sync="selectOrderPopupShow" :disabledData="projectDetail.order_list" :selectData="formData.relate"  @success="successRefresh"/>
        <SelectBusiness v-if="selectBusinessPopupShow" :selectBusinessPopupShow.sync="selectBusinessPopupShow" :disabledData="projectDetail.business_list" :selectData="formData.relate"  @success="successRefresh"/>
        <SelectWorkOrder v-if="selectWorkOrderPopupShow" :selectWorkOrderPopupShow.sync="selectWorkOrderPopupShow" :disabledData="projectDetail.work_order_list" :selectData="formData.relate" @success="successRefresh"/>
    </van-popup>


</template>
<script>
import {ProjectManageRelate } from "@/api/index.js"
import SelectOrder from "./select_order.vue";
import SelectBusiness from "./select_business.vue";
import SelectWorkOrder from "./select_work_order.vue";
export default {
    name: "relate_form",
    components: {
        SelectOrder,SelectBusiness,SelectWorkOrder
    },
    props: {
        relateFormPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        projectDetail: {
            type: Object,
            default: ()=>{}
        },
        relateType: {
            type: String,
            default: 'relate_business'
        },
    },

    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            btnDisabled:false,
            formData: {

                sync:[],
                relate:[],
            },
            formRules: {
                relate: [{required: true, message: "请选择关联", trigger: 'onChange'}],
            },
            selectOrderPopupShow:false,
            selectBusinessPopupShow:false,
            selectWorkOrderPopupShow:false,
        }
    },
    created() {

    },
    methods: {
        toggle(ref) {
            this.$refs[ref].toggle();
        },
        // 关联的操作回调
        successRefresh(data){
            if(this.relateType == 'relate_order'){
                this.formData.relate = data.map((item)=>{ return {order_id:item.order_id,order_num:item.order_num}})
            }else if(this.relateType == 'relate_business'){
                this.formData.relate =data.map((item)=>{ return {project_id:item.project_id,project_name:item.project_name}})
            }else if(this.relateType == 'relate_work_order'){
                this.formData.relate = data.map((item)=>{ return {workorder_id:item.workorder_id,workorder_num:item.workorder_num, }})
            }
            console.log(this.formData);
        },
        handleClickClose() {
            this.$emit("update:relateFormPopupShow", false)
        },
        handleClickConfirm() {
            this.$refs.formData.validate().then(() => {
                    if(this.relateType == 'relate_business'){ //关联商机
                        let postData = {
                            id: this.projectId,
                            relate_type:'project',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.project_id,relate_num:'',project_name:item.project_name}}),
                        }
                        this.btnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$toast({
                                    message:res.message,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit("update:relateFormPopupShow", false)
                                        this.$emit('success')
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    }if(this.relateType == 'relate_order'){ //关联订单
                        let postData = {
                            id: this.projectId,
                            relate_type:'order',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.order_id,relate_num:item.order_num}}),
                        }
                        this.btnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$toast({
                                    message:res.message,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit("update:relateFormPopupShow", false)
                                        this.$emit('success')
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    }if(this.relateType == 'relate_work_order'){ //关联工单
                        let postData = {
                            id: this.projectId,
                            relate_type:'workorder',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.workorder_id,relate_num:item.workorder_num}}),
                        }
                        this.btnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$toast({
                                    message:res.message,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit("update:relateFormPopupShow", false)
                                        this.$emit('success')
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    }
            })
        },



    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
